import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useServicesLinkClick } from '../../../../../../shared';
import type { NavLinkModel } from '../../../../../../types';
import './overview-link.scss';
type OverviewLinkProps = {
  link: NavLinkModel;
  onSelect: () => void;
};
export function OverviewLink(t0) {
  const $ = _c(11);
  const {
    link,
    onSelect
  } = t0;
  const handleServicesLinkClick = useServicesLinkClick();
  const t1 = link.openInNewTab ? "noopener noreferrer" : undefined;
  const t2 = link.openInNewTab ? "_blank" : undefined;
  let t3;
  if ($[0] !== handleServicesLinkClick || $[1] !== link.href || $[2] !== link.openInNewTab || $[3] !== onSelect) {
    t3 = event => {
      handleServicesLinkClick({
        event,
        link: link.href,
        shouldOpenInNewTab: link.openInNewTab
      });
      onSelect();
    };
    $[0] = handleServicesLinkClick;
    $[1] = link.href;
    $[2] = link.openInNewTab;
    $[3] = onSelect;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== link.href || $[6] !== link.label || $[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <Link href={link.href} className="mobile-menu-overview-link" rel={t1} target={t2} onClick={t3}>{link.label}</Link>;
    $[5] = link.href;
    $[6] = link.label;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}